import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectStoreAndOutlet } from '@/store/slices/storeSlice';
import { useSettings } from '@/hooks/useSettings';
import { getLogoUrl } from '@/utils/imageUrl';

/**
 * Dynamically updates the page title and favicon based on the current store/outlet.
 */
export function useFavicon() {
  const { storeName, outletName } = useSelector(selectStoreAndOutlet);
  const { settings } = useSettings();

  // Update document title
  useEffect(() => {
    if (storeName && outletName) {
      document.title = `${storeName} - ${outletName}`;
    } else if (storeName) {
      document.title = storeName;
    } else {
      document.title = 'Ankassa';
    }
  }, [storeName, outletName]);

  // Update favicon
  useEffect(() => {
    const logoUrl = settings?.logoUrl ? getLogoUrl(settings.logoUrl) : null;
    let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");

    // Create favicon link element if it doesn't exist
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    if (logoUrl) {
      link.href = logoUrl;
      link.type = '';
    } else {
      link.href = '/assets/logo.svg';
      link.type = 'image/svg+xml';
    }
  }, [settings?.logoUrl]);
}
